import { render } from "./IconBinn.vue?vue&type=template&id=77d89a76"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBinn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77d89a76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77d89a76', __exports__)) {
    api.reload('77d89a76', __exports__)
  }
  
  module.hot.accept("./IconBinn.vue?vue&type=template&id=77d89a76", () => {
    api.rerender('77d89a76', render)
  })

}


export default __exports__